<template>
  <b-container fluid>
    <b-row class="px-0 py-3">
      <b-col cols="12" md="6" v-for="(item, index) in beneficiaryList" :key="item.id" class="px-2">
        <div class="block-item mb-4 p-3">
          <div class="title-item d-flex align-items-center">
            <img :src="`${publicPath}/img/gep/3.svg`" />
            <div class="card-number px-2 fw-600 fz-24">
              {{ item.accountName }}
            </div>
          </div>
          <hr />
          <div class="d-flex fw-500 fz-16 mb-2">
            <div class="text-grey7">Card Number</div>
            <div class="ml-auto fw-600">{{ item.cardNo }}</div>
          </div>
          <div class="d-flex fw-500 fz-16 mb-2">
            <div class="text-grey7">Bank Name</div>
            <div class="ml-auto fw-600">{{ item.bankName }}</div>
          </div>
          <div class="d-flex fw-500 fz-16 mb-4">
            <div class="text-grey7">Currency</div>
            <div class="ml-auto fw-600">{{ item.accountCcy }}</div>
          </div>
          <div class="d-flex fw-500 fz-16 mb-2">
            <button class="btn btn-primary ml-auto" @click="updatePartner(item.id)">
              Update
            </button>
          </div>
        </div>
      </b-col>
      <b-col v-if="beneficiaryList.length == 0" cols="12">
        {{ $t("No history found") }}
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Withdrawal from "@/services/Withdrawal";

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL !== "/" ? process.env.BASE_URL : "",
      isLoading: false,
      userType: "2",
      data: [],
      search: "",
      currentPage: 1,
      perPage: 10,
      beneficiaryList: [],
    };
  },
  props: ["userNo"],
  methods: {
    updatePartner(id) {
      localStorage.removeItem("partner_update");
      localStorage.removeItem("bank_info_update");

      this.$router.push({
        path: "/update-partner",
        query: { id: id },
      });
    },
    doSearch() {
      let self = this;
      var opt = {
        userNo: this.userNo,
        page: this.currentPage,
        pagesize: this.perPage,
        sort: "-updated_at",
      };

      Withdrawal.partnerList(opt).then((response) => {
        if (response.status == 200) {
          console.log(response.data);
          self.beneficiaryList = response.data;
        }
      });
    },
    checkError(err) {
      const response = err.response;
      try {
        if (response.status == 401 && response.data.name == "Unauthorized") {
          localStorage.removeItem("token");
          localStorage.removeItem("member");
          localStorage.removeItem("isFirstTime");
          this.$router.push({
            path: "/login",
          });
        } else {
          if (localStorage.getItem("token")) {
            var msg = response.data ? response.data.message : err.message;
            this.$notify({
              type: "warn",
              text: msg,
            });
          }
        }
      } catch (e) {
        console.log(err);
      }
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      self.doSearch();
    });
  },
  destroyed() { },
};
</script>

<style scoped>
.block-account {
  background: #f8f9fa;
  border-radius: 8px;
}
</style>
